import { LwApiPM } from "@techniaorg/liteweb-api";
import { LwRotation } from "@techniaorg/liteweb-api/dist/types/lw-public-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

let params: LwRotation = { enable: false, speed: 0, axis: [0, 0, 1] };

function start(enable: boolean) {
  params.enable = enable;
  LwAPI?.setRotation(params);
}

function changeSpeed(speed: number) {
  params.speed = speed;
  LwAPI?.setRotation(params);
}

function changeAxis(axis: [number, number, number]) {
  params.axis = axis;
  LwAPI?.setRotation(params);
}

document.getElementById("start")?.addEventListener("click", async () => {
  await apiReady;
  start(true);
});

document.getElementById("stop")?.addEventListener("click", async () => {
  await apiReady;
  start(false);
});

document.getElementById("slow")?.addEventListener("click", async () => {
  await apiReady;
  changeSpeed(0);
});

document.getElementById("medium")?.addEventListener("click", async () => {
  await apiReady;
  changeSpeed(1);
});
document.getElementById("fast")?.addEventListener("click", async () => {
  await apiReady;
  changeSpeed(2);
});

document.getElementById("slow")?.addEventListener("click", async () => {
  await apiReady;
  changeSpeed(0);
});

document.getElementById("xaxis")?.addEventListener("click", async () => {
  await apiReady;
  changeAxis([1, 0, 0]);
});

document.getElementById("yaxis")?.addEventListener("click", async () => {
  await apiReady;
  changeAxis([0, 1, 0]);
});

document.getElementById("zaxis")?.addEventListener("click", async () => {
  await apiReady;
  changeAxis([0, 0, 1]);
});

document.getElementById("diagonal")?.addEventListener("click", async () => {
  await apiReady;
  changeAxis([1, 1, 0]);
});
